const Banner = '/assets/lineaazul/home/banner.png';
const BookingActive = '/assets/lineaazul/home/search/comprar-sel.svg';
const BookingInActive = '/assets/lineaazul/home/search/comprar-active.svg';
const CancelActive = '/assets/lineaazul/home/search/anular-sel.svg';
const CancelInActive = '/assets/lineaazul/home/search/cancel-active.svg';
const ChangeActive = '/assets/lineaazul/home/search/confirmar-active.svg';
const ChangeInActive = '/assets/lineaazul/home/search/confirmar-active.svg';
const CuponActive = '/assets/lineaazul/home/search/couponera-active.svg';
const CuponInActive = '/assets/lineaazul/home/search/couponera-active.svg';
const Whatsapp = '/assets/lineaazul/contact/whatsapp.svg';
const Email = '/assets/lineaazul/contact/email.svg';
const HeadPhone = '/assets/lineaazul/contact/headphone.svg';
const pnr = '/assets/lineaazul/general/find-my-pnr.svg';

const success = '/assets/lineaazul/blue/checkmark.svg';
const failure = '/assets/lineaazul/blue/information.svg';
const tick = '/assets/lineaazul/blue/tick.svg';
const heartOn = '/assets/lineaazul/blue/hearton.svg';
const heartOff = '/assets/lineaazul/blue/heartoff.svg';
const downArrow = '/assets/lineaazul/blue/downarrow.svg';
const userIcon = '/assets/lineaazul/blue/userreddot.svg';
const trips = '/assets/lineaazul/blue/trips.svg';
const wallet = '/assets/lineaazul/blue/wallet.svg';
const cards = '/assets/lineaazul/blue/cards.svg'
const transaction = '/assets/lineaazul/blue/sharemoney.svg';
const otp = '/assets/lineaazul/blue/respwd.svg';
const registrationSuccess = '/assets/lineaazul/blue/respwd.svg';


const YellowLine = '/assets/lineaazul/home/search/yellow-line.png';
const OriginIcon = '/assets/lineaazul/home/search/origin.svg';
const DestinationIcon = '/assets/lineaazul/home/search/destination.svg';
const pin = '/assets/lineaazul/home/search/destination.svg';
const CalendarIcon = '/assets/lineaazul/home/search/calendar.svg';
const checkboxIcon = '/static/images/icons/BusOperatorsWebsite-Checkbox.png';
const animation = '/static/images/animations/Services-kupos-PasajeBus-Orange.gif';


const PopupIcon = '/assets/kennybus/general/Pop-up.jpg';

// Icons Section
const ist = '/assets/kennybus/icons/seat-icon.svg';
const second = '/assets/kennybus/icons/charging-icon.svg';
const third = '/assets/kennybus/icons/ticket-icon.svg';
const close = '/assets/kennybus/icons/close.svg';



const paso_1 = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RechargeWallet-Orange.svg';
const paso_2 = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RechargePoints-Orange.svg';
const paso_3 = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-ID-Orange.svg';
const paso_4 = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Tickets-Orange.svg';


const lineaazulIcons = [

	{ icon: downArrow, name: 'downArrow' },
	{ icon: userIcon, name: 'userIcon' },
	{ icon: trips, name: 'trips' },
	{ icon: cards, name: 'cards' },
	{ icon: wallet, name: 'wallet' },
	{ icon: transaction, name: 'transaction' },
	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: tick, name: 'tick' },
	{ icon: heartOn, name: 'heartOn' },
	{ icon: heartOff, name: 'heartOff' },
	{ icon: registrationSuccess, name: 'registrationSuccess' },
	{ icon: otp, name: 'otp' },

	{ icon: paso_1, name: 'paso_1' },
	{ icon: paso_2, name: 'paso_2' },
	{ icon: paso_3, name: 'paso_3' },
	{ icon: paso_4, name: 'paso_4' },

	{ icon: Banner, name: 'Banner' },

	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },


	{ icon: OriginIcon, name: 'Origin' },
	{ icon: DestinationIcon, name: 'Destination' },
	{ icon: pin, name: 'pin' },
	{ icon: CalendarIcon, name: 'Calendar' },

	{ icon: BookingInActive, name: 'BIA' },
	{ icon: BookingActive, name: 'BA' },
	{ icon: CancelInActive, name: 'CIA' },
	{ icon: CancelActive, name: 'CA' },
	{ icon: ChangeActive, name: 'CTIA' },
	{ icon: ChangeInActive, name: 'CTA' },
	{ icon: CuponInActive, name: 'CUIA' },
	{ icon: CuponActive, name: 'CUA' },

	{ icon: PopupIcon, name: 'Popup' },

	{ icon: Whatsapp, name: 'Whatsapp' },
	{ icon: Email, name: 'Email' },
	{ icon: HeadPhone, name: 'Headphone' },
	{ icon: YellowLine, name: 'Line' },

	{ icon: animation, name: 'animation' },
	{ icon: checkboxIcon, name: 'Checkbox' },

	// Icons Section
	{ icon: ist, name: 'ist' },
	{ icon: second, name: 'second' },
	{ icon: third, name: 'third' },
	{ icon: pnr, name: 'pnr' },
	{ icon: close, name: 'close' },
];

export default lineaazulIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/lineaazulIcons.js